var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.76469 13.7193C2.58937 13.719 2.42224 13.6401 2.30407 13.502C2.18372 13.365 2.12392 13.1797 2.13969 12.9927L2.29282 11.1967L9.36657 3.65399L11.5772 6.01132L4.50532 13.5533L2.82157 13.7167C2.80219 13.7187 2.78282 13.7193 2.76469 13.7193ZM12.0184 5.53999L9.80844 3.18265L11.1341 1.76865C11.2513 1.64347 11.4104 1.57313 11.5763 1.57313C11.7421 1.57313 11.9012 1.64347 12.0184 1.76865L13.3441 3.18265C13.4614 3.3077 13.5274 3.47738 13.5274 3.65432C13.5274 3.83126 13.4614 4.00094 13.3441 4.12599L12.0191 5.53932L12.0184 5.53999Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c85b3c13589428a7537cbd3a0ed8502d.svg";
export { ForwardRef as ReactComponent };